export default "__VITE_ASSET__cd25ca32__"